import { createStore } from 'vuex'
import { ServiceFactory } from '../services/factory'
const Service = ServiceFactory.get('service')
// //////Make Sure to clean at logout.vue


export default createStore({
  state: {
    status: '',
    user: [],
    menues: [],
    permissions: [],
    types:[],
    userType: null
  },
  mutations: {
    user_request (state) {
      state.status = 'loading'
    },
    user_success (state, userInfo) {
      state.status = 'success'
      state.user = userInfo
    },
    menues_success (state, menues) {
      state.status = 'success'
      state.menues = menues
    },
    permissions_success (state, permissions) {
      state.status = 'success'
      state.permissions = permissions
    },
    types_success (state, types) {
      state.status = 'success'
      state.types = types
    },
    SET_USER_TYPE (state, userType) {
      state.userType = userType
    },
    user_error (state) {
      state.status = 'error'
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('user_request')
        if (this.getters.menues.length > 0) {
          resolve(this.getters.user)
          resolve(this.getters.menues)
          resolve(this.getters.permissions)
          resolve(this.getters.types)
        } else {
          Service.get('auth')
            .then(response => {
              commit('user_success', response.data.user)
              commit('menues_success', response.data.menues)
              commit('permissions_success', response.data.permissions)
              commit('types_success', response.data.types)
              resolve(response)
            })
            .catch(err => {
              commit('user_error')
              reject(err)
            })
        }
      })
    }
  },
  getters: {
    user: state => state.user,
    menues: state => state.menues,
    permissions: state => state.permissions,
    types: state => state.types,
    getPermission: state => (route) => {
      var permissions = { Search: false, View: false, Manage: false, Add: false, Edit: false, Delete: false, Import: false }
      if (state.permissions) {
        state.permissions.filter(function (item) {
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'view') {
            permissions.Search = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'view') {
            permissions.View = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'manage') {
            permissions.Manage = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'add') {
            permissions.Add = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'edit') {
            permissions.Edit = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'delete') {
            permissions.Delete = true
          }
          if (item.route.toLowerCase() === route.toLowerCase() && item.permissionName.toLowerCase() === 'import') {
            permissions.Import = true
          }
        })
      }
      return permissions
    },
    getViewCompaniesPermission: state => (route) => {
      var permissions = []
      if (state.permissions) {
        var keys = ['route']
        permissions = state.permissions.filter(function (item) {
          return keys.some(key =>
            (String(item[key]).toLowerCase().includes(route.toLowerCase()) && item.permissionName.toLowerCase() === 'view')
          )
        })
      }
      var companyArray = []
      for (const perm of permissions) {
        companyArray.push(perm.companyId)
      }
      return companyArray
    },
    userType: state => state.userType,
    hasPermission: (state) => (controller, action) => {
      return state.permissions.some(p =>
        p.permissionBase === controller && p.permissionName === action
      )
    },
    hasWidgetPermission: (state) => (widget) => {
      if (!widget.requiredPermission && !widget.requiredPermissions) {
        return true // Widget has no permission requirements
      }
      
      // Handle multiple permissions (array)
      if (Array.isArray(widget.requiredPermissions)) {
        const logic = widget.permissionLogic || 'OR'
        
        if (logic === 'AND') {
          // User must have ALL permissions
          return widget.requiredPermissions.every(req =>
            state.permissions.some(p =>
              p.permissionBase === req.controller &&
              p.permissionName === req.action
            )
          )
        } else {
          // User must have AT LEAST ONE permission (OR logic)
          return widget.requiredPermissions.some(req =>
            state.permissions.some(p =>
              p.permissionBase === req.controller &&
              p.permissionName === req.action
            )
          )
        }
      }
      
      // Handle single permission (object)
      return state.permissions.some(p =>
        p.permissionBase === widget.requiredPermission.controller &&
        p.permissionName === widget.requiredPermission.action
      )
    },
    availableWidgets: (state, getters) => (widgetConfig) => {
      return Object.values(widgetConfig)
        .filter(widget => getters.hasWidgetPermission(widget))
        .sort((a, b) => a.order - b.order)
    }
  }
})
